import React from 'react';
import { Button, Modal } from "react-bootstrap";

interface Props {
  open: boolean;
  message?: string;
  cancelText?: string;
  confirmText?: string;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmDialog = (props: Props) => {
  const { open, onClose, onConfirm, message, cancelText, confirmText } = props;

  return (
    <Modal show={open} onHide={onClose} className="confirm-dialog" centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="content">
          {message}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onClose}>{cancelText}</Button>
        <Button variant="danger" onClick={onConfirm}>{confirmText}</Button>
      </Modal.Footer>
    </Modal>
  )
}

ConfirmDialog.defaultProps = {
  message: 'Are you sure?',
  cancelText: 'No',
  confirmText: 'Yes'
};

export default ConfirmDialog;
